import React, { useState,useEffect } from 'react';
import './payment.css'
import Sidebar from '../../components/Sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Link,useParams } from 'react-router-dom'

import BackLoader from '../../components/backloader';


import * as Constants from '../../constants';
import TopBar from '../../components/topbar';
import JisAlert from '../../components/jisalert'

function Setting() {
    const {refid} = useParams();
    const [filenames, setFilenames] = useState([]);

    const [docs, setDocs] = useState([]);
    const [caseInfo, setCaseInfo]=useState({});
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [schedule, setSchedule]= useState({});
    const [alert, setAlert] = useState({open:false})
    const [search, setSearch]= useState('');
    const [currectdoc, setCurrentDoc]=useState({});
    const [previewWindow, setPreviewWindow] = useState(false)
    const [pageIndex, setPageIndex]=useState(0);
    const [upline, setUpline]=useState({});
    const [config, setConfig]=useState({});
    

    useEffect(() => {
        onConfig();
      }, []);

    const navigate = useNavigate();
    const onOk=()=>{
        setAlert({open:false});
    }
    const onConfig= async()=>{
        
        const urls=`${Constants.apiUrl}/gazette/getsettings`;
        console.log(`the calling url ${urls}`);

        try {
           
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            const data = await resp.json();
           setConfig(data);
            
          } catch (error) {
            console.error(error);
          }   
  }

  const onSave= async()=>{
    const urls=`${Constants.apiUrl}/gazette/savesettings`;
        console.log(`the calling url ${urls}`);

        try {
           
            const resp = await fetch(urls, { 
                method: 'POST',
                body: JSON.stringify(config),
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': '',
                },
            });
            const data = await resp.json();
           if(data.code==0){
            setAlert({...alert, open:true, title:'Save Setting', subtitle:'Setting saved successfully.', onOk})
           }
            
          } catch (error) {
            console.error(error);
          }   
  }
  

  return (
    <div className='payment-records'>
        <Sidebar />
        <div className="body">
           <TopBar title="Home/Payment/Verify Document" />
            <div className="container">
               

               <div style={{width:400}}>
               <div className='form-inp' >
                    <label>Affidavit Document Amount</label>
                    <input placeholder='Affidavit Amount' type="number"  value={config.affidavitAmount} onChange={(e)=> {Constants.isNumber(e.target.value) && setConfig({...config, affidavitAmount:e.target.value})} } />
                    <label>Document Verification Amount</label>
                    <input placeholder='verificationAmount'  value={config.verificationAmount} onChange={(e)=> {Constants.isNumber(e.target.value) &&  setConfig({...config, verificationAmount:e.target.value})} } required />
                  
                 <button className='red' type='button' onClick={onSave} style={{marginTop:24}}>Save Setting</button> 
                 </div> 
               </div>

            </div>
            <div className="goBack" onClick={() =>  navigate('/categories')}>
                <FontAwesomeIcon icon={faArrowLeft} />
                <p>Back to Home </p>
            </div>
            <BackLoader open={isLoading}  />
            {alert.open && <JisAlert {...alert} />} 
        </div>
    </div>
  )
}

export default Setting